import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './frontend/Routes/App';

createRoot(
    document.getElementById('app')).render(
    <App/>);